import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Meta, Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { MainserviceService } from 'src/app/mainservice.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;


  constructor(private title: Title, private meta: Meta, private renderer: Renderer2, @Inject(PLATFORM_ID) private platformId: Object, private fb:FormBuilder, private mainservice:MainserviceService, private matsnackbar:MatSnackBar) {
    this.setSeoMeta()
    this.contactForm=this.fb.group({
      username:['',[Validators.required, Validators.pattern('^[A-Za-z \\s]+$')]],
      useremail:['',[Validators.required,  Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.com$')]],
      mobilenumber:['',[Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      msgsuubject:['',[Validators.required]],
      message:['',[Validators.required]]
    })
  }


  ngOnInit(): void {

  }
  setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';

    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');

      let lang = 'en'; // Default
      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }

      // const fullPath = path.replace(/^\/[a-z]{2}/, '');
      // finalUrl = `${origin}/${lang}${fullPath}`;
      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
      finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    }


    const seoData = {
      title: $localize`:@@CONTACT.SEO_TITLE:Contact For Retail & Pharmacy Softwares`,
      description: $localize`:@@CONTACT.SEO_DESCRIPTION:
        'Reach out to MEDEIL for expert POS support, product information, or partnership inquiries. Our team is ready to help your retail or pharmacy business succeed.`,
      image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
      url: finalUrl,
      keywords: $localize`:@@CONTACT.SEO_KEYWORDS:
        'contact MEDEIL, POS support, retail POS help, pharmacy POS assistance, POS customer service, business inquiry, POS demo request, MEDEIL contact form`
    };


    // this.seoService.setData(seoData);
    this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }
  setSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "MEDEIL Contact Us",
      "description": $localize`:@@CONTACT.SCHEMA_DESCRIPTION: Reach out to MEDEIL for expert POS support, product information, or partnership inquiries. Our team is ready to help your retail or pharmacy business succeed.`,
      "url": "https://www.medeil.com/en/coming-soon",
      "inLanguage": "en",
      "isPartOf": {
        "@type": "WebSite",
        "name": "MEDEIL",
        "url": "https://www.medeil.com"
      },
      "publisher": {
        "@type": "Organization",
        "name": "MEDEIL",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/images/logo.png"
        }
      },
      "mainEntity": {
        "@type": "Product",
        "name": "MEDEIL POS",
        "description": "Advanced retail and pharmacy point of sale system with upcoming new features",
        "brand": {
          "@type": "Brand",
          "name": "MEDEIL"
        },
        "offers": {
          "@type": "Offer",
          "availability": "https://schema.org/PreOrder",
          "url": "https://www.medeil.com/en/coming-soon"
        }
      },
      "potentialAction": {
        "@type": "SignUp",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://www.medeil.com/en/coming-soon#signup",
          "description": "Sign up for early access and updates"
        }
      }

    }
  }


  sendmsg(){

      const email = this.contactForm.get('useremail')?.value;


  if (!email.endsWith('.com')) {
    this.matsnackbar.open('Enter Valid MailID', 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['error-snackbar']
    });
    return;
  }

  if (this.contactForm.invalid) {
    this.matsnackbar.open('Please enter a valid email.', 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['error-snackbar']
    });
    return;
  }

      console.log('Form data:', this.contactForm.value);


this.mainservice.savemsg(this.contactForm.value).subscribe(res=>{
  console.log('saved', res);
});
    alert('Message sent successfully!');
}


allowOnlyLetters(event: KeyboardEvent): void {
  const pattern = /^[a-zA-Z ]$/;
  const inputChar = String.fromCharCode(event.keyCode || event.which);
  if (!pattern.test(inputChar)) {
    event.preventDefault(); // Block the character
  }
}

allowOnlyNumbers(event: KeyboardEvent): void {
  const pattern = /[0-9+]/;
  const inputChar = String.fromCharCode(event.keyCode || event.which);
  if (!pattern.test(inputChar)) {
    event.preventDefault(); // Block non-number input
  }
}

blockNonNumbers(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') ?? '';
  if (!/^\d+$/.test(pastedText)) {
    event.preventDefault(); // Block pasted content if it contains non-digits
  }
}


allowOnlyEmailCharacters(event: KeyboardEvent): void {
  const allowedPattern = /^[a-zA-Z0-9@._%+-]$/;
  const inputChar = String.fromCharCode(event.keyCode || event.which);
  if (!allowedPattern.test(inputChar)) {
    event.preventDefault(); // block if not allowed
  }
}

blockInvalidEmailPaste(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') ?? '';
  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com)$/.test(pastedText)) {
    event.preventDefault();
  }
}
}
